import React from 'react';
import styles from './GeoFeaturePanel.module.scss';

interface PolygonInfoBannerProps {
  isDrawing: boolean;
  hasVertices: boolean;
  validVertexCount: number;
}

/**
 * Isolated, memoized status banner for polygon drawing mode.
 */
export const PolygonInfoBanner: React.FC<PolygonInfoBannerProps> = React.memo(({
  isDrawing,
  hasVertices,
  validVertexCount,
}) => {
  const getBannerMessage = (): string => {
    if (isDrawing) {
      return 'Left-click to add vertices · Right-click to finish';
    }
    if (hasVertices) {
      return `${validVertexCount} vertices defined`;
    }
    return 'Draw on map or enter coordinates below';
  };

  return (
    <div className={`${styles.info} ${isDrawing ? styles.live : ''}`}>
      <span className={styles.dot} />
      {getBannerMessage()}
    </div>
  );
});

PolygonInfoBanner.displayName = 'PolygonInfoBanner';
